import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  HRService,
  setupManagementUrl,
  userManagementUrl,
} from "../../../config";
import {
  allLeaveTypes,
  allRelievers,
  allUsers,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { leaveApplicationFields } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { fetchJson } from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = HRService.uri;

const LeaveApplicationForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
const formatDate = (date) => {
    if (!date) return null; // Handle null or undefined dates
    return date.split("T")[0]; // Extract the date part
  };
  const initialValues = {
    startDate: props.data ? formatDate(props.data.StartDate) : "",
    endDate: props.data ? formatDate(props.data.EndDate) : "",
    resumptionDate: props.data ? props.data.ResumptionDate : "",
    leaveTypeId: props.data ? props.data.LeaveTypeId : "",
    companyId: props.data ? props.data.CompanyId : companyId,
    userId: props.data ? props.data.UserId : null,
    autoAccessCase: props.data ? props.data.AutoAccessCase : false,
    autoAccessDocuments: props.data ? props.data.AutoAccessDocuments : false,
  };

  async function fetchLeaveTypes() {
    try {
      const data = await fetchJson({
        objectName: "allLeaveTypes", 
        baseUrl: HRService.uri
      });
      if (data) {
        setLeaveTypes(JSON.parse(data.results) || []);
      }
      const usersdata = await fetchJson({
        objectName: "relievers", 
        baseUrl: base_url
      });
      if (usersdata) {
        setUsers(JSON.parse(usersdata.results));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    let isMounted = true;
    fetchLeaveTypes();
    return () => {
      isMounted = false;
    };
  }, []);

  const LeaveTypeOptions = leaveTypes
    ? leaveTypes.map((type) => ({
        value: type.Id,
        label: type.Type,
      }))
    : [];
  const usersOptions = users
    ? users.map((type) => ({
        value: type.Id,
        label: type.Username,
      }))
    : [];
  const fields = [
    {
      name: "leaveTypeId",
      label: "Leave Type",
      type: "select",
      options: LeaveTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "userId",
      label: "Reliever(s)",
      type: "multiselect",
      options: usersOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      required: true,
      gridColumn: "span 2",
    },
    ...leaveApplicationFields,
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { startDate, endDate, leaveTypeId } = values;
      const relievers = [];

      values.userId.forEach((userId) => {
        const assignmentObject = {
          userId: userId,
          // autoAccessDocuments: values.autoAccessDocuments,
          // autoAccessCase: values.autoAccessCase,
        };

        relievers.push(assignmentObject);
      });
      const mutationData = {
        leave: {
          startDate,
          endDate,
          id: props.isEditing ? props.data.Id : null,
          leaveTypeId,
          companyId,
          userId,
        },
        relievers: relievers,
      };
      // if (props.isEditing) {
      //   mutationData.id = props.data.Id;
      // }
      const response = await MutationWithArrayInput(
        props.isEditing ? "updateLeaveApplication" : "createLeaveApplication",
        mutationData,
        null,
        base_url
      );
      const returnObjectName = props.isEditing
        ? response.updateLeaveApplication
        : response.createLeaveApplication;
        const parsedResults = returnObjectName?.results
          ? JSON.parse(returnObjectName.results)
          : null;
      if (parsedResults?.StatusCode === 200) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Leave application ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: parsedResults?.ErrorMessage || "An unexpected error occurred.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Update Leave Application"
          : "Create Leave Application"
      }
      subtitle={
        props.isEditing
          ? "Fill out the form below to update leave application."
          : "Fill out the form below to apply for leave."
      }
    />
  );
};

export default LeaveApplicationForm;
